export default (state = {}, action) => {
  switch (action.type) {
    case "FETCH_SCHEDULE_FULFILLED":
      const { meta, payload } = action;
      return {
        ...state,
        [meta.division]: payload.data
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/schedule/scheduleReducer.js